var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M70 40c0 16.569-13.431 30-30 30-16.568 0-30-13.431-30-30 0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30m-21.428-9.429a8.571 8.571 0 1 1-17.143 0 8.571 8.571 0 0 1 17.143 0M40 58.001c6.627 0 12-3.43 12-5.144 0-6.627-5.373-12-12-12s-12 5.373-12 12C28 54.572 33.373 58 40 58",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;